<template>
  <rect width="90" height="48" rx="3" fill="#3E3E3E" />
  <circle cx="21" cy="24" r="9" fill="#F3F3F3" />
  <circle cx="45" cy="24" r="9" fill="#97A1BA" />
  <circle cx="69" cy="24" r="9" fill="#9FB4FF" />
</template>
